export const getSeverityLevelList = (t) => {
  return [
    {
      id: 3,
      name: t('Extreme'),
    },
    {
      id: 2,
      name: t('Severe'),
    },
    {
      id: 4,
      name: t('Moderate'),
    },
    {
      id: 1,
      name: t('Minor'),
    },
  ];
};
